/**
 * retrieveUser module
 * Checks if user has variables in localStorage of if zmailZchoolName is valid in Cognito
 * before returning a promise with the purpose of fetching both session tokens
 * and user credentials
 */

import { CognitoUserPool } from 'amazon-cognito-identity-js';
import schoolConstants from '../constants/schoolConstants';
import getCredentials from './getCredentials';
import getCurrentUser from './getCurrentUser';
import getUserAttributes from './getUserAttributes';

function retrieveUser() {
  if (localStorage.zmailSchoolName && localStorage.zmailSchoolName.indexOf('%20'))
    localStorage.zmailSchoolName = localStorage.zmailSchoolName.replace('%20', '');
  var schoolName = localStorage.zmailSchoolName;
  var cognitoUser = getCurrentUser();
  if (typeof schoolName === 'undefined') {
    // @TODO find a way to redirect user to login (maybe redux is needed)
    // Login.props.history.replace('/login');
    return Promise.reject(new Error('No school in local storage'));
  } else if (cognitoUser == null) {
    return Promise.reject(new Error('Cannot get current user'));
  }

  // update local storage
  var username = cognitoUser.username;
  localStorage.zmailUsername = username;

  var userPromise = new Promise((resolve, reject) => {
    getCredentials().then(() => {
      getUserAttributes()
        .then((userAttributes) => {
          if (userAttributes.email_verified === 'false' || !userAttributes.email_verified) {
            resolve('emailVerification');
            var email = userAttributes.email;
          } else {
            // @TODO: change update logged in to True (formerly through dispatch)
            resolve();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  });

  return userPromise;
}

export default retrieveUser;



// WEBPACK FOOTER //
// ./src/authentication/retrieveUser.js